import React, { useState } from 'react';
import { Plus, Search, Filter, LayoutGrid, List } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/Tabs';
import { mockServiceOrders, mockClients, mockVehicles } from '../data/mockData';
import { Badge } from '../components/ui/Badge';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { formatCurrency, formatDate } from '../lib/utils';
import { Link } from 'react-router-dom';
import { StatusBadge, statusConfig } from '../components/service-orders/StatusBadge';
export function ServiceOrders() {
  const [view, setView] = useState<'kanban' | 'list'>('kanban');
  return <div className="h-full flex flex-col space-y-6" data-id="element-994">
      <div className="flex items-center justify-between" data-id="element-995">
        <div data-id="element-996">
          <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-997">
            Ordens de Serviço
          </h1>
          <p className="text-muted-foreground mt-1" data-id="element-998">
            Gerencie os serviços em andamento.
          </p>
        </div>
        <Button className="gap-2" data-id="element-999">
          <Plus className="h-4 w-4" data-id="element-1000" /> Nova OS
        </Button>
      </div>

      <div className="flex items-center justify-between gap-4" data-id="element-1001">
        <div className="flex flex-1 items-center gap-2 max-w-md" data-id="element-1002">
          <div className="relative flex-1" data-id="element-1003">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" data-id="element-1004" />
            <Input placeholder="Buscar por placa, cliente ou nº da OS..." className="pl-9" data-id="element-1005" />
          </div>
          <Button variant="outline" size="icon" data-id="element-1006">
            <Filter className="h-4 w-4" data-id="element-1007" />
          </Button>
        </div>

        <Tabs value={view} onValueChange={v => setView(v as 'kanban' | 'list')} data-id="element-1008">
          <TabsList data-id="element-1009">
            <TabsTrigger value="kanban" className="gap-2" data-id="element-1010">
              <LayoutGrid className="h-4 w-4" data-id="element-1011" /> Kanban
            </TabsTrigger>
            <TabsTrigger value="list" className="gap-2" data-id="element-1012">
              <List className="h-4 w-4" data-id="element-1013" /> Lista
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {view === 'kanban' ? <div className="flex-1 overflow-x-auto pb-4" data-id="element-1014">
          <div className="flex gap-4 h-full min-w-max" data-id="element-1015">
            {Object.entries(statusConfig).map(([status, config]) => {
          const columnOrders = mockServiceOrders.filter(os => os.status === status);
          return <div key={status} className="w-80 flex flex-col gap-3" data-id="element-1016">
                  <div className="flex items-center justify-between pb-2" data-id="element-1017">
                    <h3 className="font-medium text-sm text-muted-foreground" data-id="element-1018">
                      {config.label}
                    </h3>
                    <Badge variant="secondary" className="rounded-full" data-id="element-1019">
                      {columnOrders.length}
                    </Badge>
                  </div>
                  <div className="flex-1 flex flex-col gap-3 bg-muted/50 rounded-xl p-2" data-id="element-1020">
                    {columnOrders.map(os => {
                const client = mockClients.find(c => c.id === os.clientId);
                const vehicle = mockVehicles.find(v => v.id === os.vehicleId);
                return <Link key={os.id} to={`/app/ordens/${os.id}`} className="block" data-id="element-1021">
                          <Card className="cursor-grab active:cursor-grabbing hover:border-primary/50 transition-colors" data-id="element-1022">
                            <CardHeader className="p-4 pb-2" data-id="element-1023">
                              <div className="flex items-center justify-between" data-id="element-1024">
                                <span className="font-mono text-xs font-medium text-muted-foreground" data-id="element-1025">
                                  {os.number}
                                </span>
                                <StatusBadge status={os.status} data-id="element-1026" />
                              </div>
                              <CardTitle className="text-base mt-2" data-id="element-1027">
                                {vehicle?.model}
                              </CardTitle>
                            </CardHeader>
                            <CardContent className="p-4 pt-0" data-id="element-1028">
                              <div className="text-sm text-muted-foreground mb-3" data-id="element-1029">
                                {client?.name} • {vehicle?.plate}
                              </div>
                              <div className="flex items-center justify-between text-sm" data-id="element-1030">
                                <span className="font-medium" data-id="element-1031">
                                  {formatCurrency(os.total)}
                                </span>
                                <span className="text-xs text-muted-foreground" data-id="element-1032">
                                  {formatDate(os.createdAt)}
                                </span>
                              </div>
                            </CardContent>
                          </Card>
                        </Link>;
              })}
                  </div>
                </div>;
        })}
          </div>
        </div> : <div className="bg-card border rounded-xl flex-1" data-id="element-1033">
          <div className="p-8 text-center text-muted-foreground" data-id="element-1034">
            Visualização em lista em desenvolvimento.
          </div>
        </div>}
    </div>;
}